"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlineChart = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.HeadlineChart = function (_a) {
    var className = _a.className, width = _a.width, height = _a.height, color = _a.color;
    return (react_1.default.createElement("svg", { width: width, height: height, className: className, viewBox: "1 2 22 20", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { fill: color !== null && color !== void 0 ? color : "#B0BECA", fillRule: "evenodd" },
            react_1.default.createElement("path", { fillOpacity: ".45", d: "M1 18h10v4H1zM13 18h10v4H13z" }),
            react_1.default.createElement("path", { d: "M10.05367232 8.20621469L5.75706215 2H9.3559322l2.7725989 4.55367232L14.7909605 2h3.4703389l-4.2048022 6.15112994L18.7570621 15h-3.59887l-3.1765537-5.23305085L8.89689266 15H5.5z" }))));
};
//# sourceMappingURL=HeadlineChart.js.map